import React, {useState} from 'preact/hooks';
import {head, isEmpty} from "lodash";
import classes from './Menu.module.css';

export default function Menu({items = [], scrollTo=true,defaultSelectedKeys, className}) {
    //控制选中样式显示在哪个li的state
    const [isActive, setIsActive] = useState(defaultSelectedKeys || head(items).key);
    //点击跳转指定位置
    function skipTo(id){
        if(id){
            //距离顶部的距离(减去导航栏高度)
            const offsetTop = document.getElementById(id).offsetTop - 64;
            //跳转到指定位置
            window.scrollTo({
                top:offsetTop,
                left:0,
                behavior:'smooth'
            })
        }
    }

    return (
        <ul className={classes.menuUl}>
            {
                !isEmpty(items) && items.map(res => (
                    <li
                        className={`${classes.menuLi} ${className} ${isActive == res.key && classes.active}`}
                        onClick={() => {
                            scrollTo && skipTo(res?.href?.slice(1))
                            setIsActive(res?.key);
                        }}
                        key={res?.key}
                    >
                        {res?.label}
                    </li>
                ))
            }
        </ul>
    )
}
